import moment from "moment";
import { formatCurrency } from "../../../../services/format";

import { FormItemType } from "../../../UI/view/component-map";
import { DataSource } from "../../../UI/view/data-source";
import { FormView } from "../../../UI/view/form-view";
import { FilterType, ListView, ListViewColumnType, initListView } from "../../../UI/view/list-view";
import { initView } from "../../../UI/view/view";
import { BillingLiquidRentalListView } from "./liquidrental-invoice-list";
import { months } from "../../../../services/date-helpers";
import { billingPermissions } from "../billing-datasource";
import { InsertBilling, InvoiceAllLiquidRentals, getLiquidRental, getLiquidRentalsMTD, getLiquidRentalsUnbilled } from "../../../../services/requests/billing/liquid-rental-billing-requests";
import { missingRentalPricingColumn } from "./liquidrental-missing-pricing";

export const liquidrentalordersDS = {
  name: 'liquidrentalbill',
  pk: 'pk',
  request: getLiquidRentalsUnbilled,
  updateRequest: InsertBilling,
  entityRequest: getLiquidRental,
  skipLocalUpdate: true,
} as DataSource;
export const liquidrentalMTDDS = {
  name: 'liquidrentalmtd',
  pk: 'pk',
  request: getLiquidRentalsMTD,
  updateRequest: InsertBilling,
  entityRequest: getLiquidRental,
  skipLocalUpdate: true,
} as DataSource;

///create function that takes the first 1000 items in an array and returns them


export const liquidRentalOrdersList = {
  autoCheckAll: true,
  disableSelection: true,
  toolbar: [
    {
      type: FormItemType.button,
      label: 'Invoice All Unbilled Rentals',
      handler: async ({ getValues, confirm, loadEntity }) => {
        const proceed = await confirm('Are you sure you want to invoice all Unbilled Rentals?');
        if (proceed) {
          const myVals = getValues();
          console.log(myVals)
          try {
            await InvoiceAllLiquidRentals();
            await confirm('Rentals invoiced Successfully', true);
            loadEntity();
          } catch {
            await confirm('There was an error invoicing rentals', true)
          }

        }
      }
    },
  ],
  columns: [
    {
      type: ListViewColumnType.icon,
      id: 'trafficStatus',
      accessor: ({ invoiceYear, invoiceMonth }) => moment().year() == invoiceYear && moment().month() + 1 == invoiceMonth ? 'clock-history' : 'currency-dollar',
      tooltip: ({ invoiceYear, invoiceMonth }) => moment().year() == invoiceYear && moment().month() + 1 == invoiceMonth ? 'MTD' : 'Unbilled',
    },
    {
      Header: 'Customer Name',
      accessor: 'customerName',
      type: ListViewColumnType.linkEdit,
      linkPath: ({ val, row }) => '/billing/liquidrentalinvoice/' + row.original.pk
    },
/*     {
      Header: 'CST',
      accessor: 'liquidCustomerId'
    }, */
    {
      Header: 'Year',
      accessor: 'invoiceYear'
    },
    {
      Header: 'Month',
      id: 'invoiceMonth',
      accessor: ({invoiceMonth}) => months[invoiceMonth]
    },
    {
      Header: '	Number of Bookings Unbilled For Month',
      accessor: 'counter'
    },
    {
      Header: 'Total Amount ($)',
      accessor: 'total',
      Cell: ({ row: { original: { total } } }) => formatCurrency(total),
    },
    missingRentalPricingColumn,
/*     {
      Header: 'Order Number',
      accessor: 'orderNumber',
      hidden: true
    }, */
/*     {
      Header: 'Priority',
      id: 'priority',
      defaultSort: true,
      defaultSortDirection: 'desc',
      accessor: ({ invoiceYear, invoiceMonth }) => {
        console.log(moment().year())
        console.log(moment().month())
        return moment().year() == invoiceYear && moment().month() + 1 == invoiceMonth ? 2 : 1;
      },
      hidden: true 
    }, */
    {
      Header: 'RecordType',
      id: 'recordType',
      accessor: ({ invoiceYear, invoiceMonth }) => moment().year() == invoiceYear && moment().month() + 1 == invoiceMonth ? 'MTD' : 'Unbilled',
      hidden: true
    },
/*     {
      Header: 'Free Days',
      accessor: 'freeDays',
      hidden: true
    }, */
  ]
} as ListView;

export const LiquidRentalsListView = initListView({...liquidRentalOrdersList, columns: liquidRentalOrdersList.columns.filter(c => c.accessor != 'total')}, liquidrentalordersDS);
export const LiquidRentalsListViewMTD = initListView(liquidRentalOrdersList, liquidrentalMTDDS);

export const LiquidRentalsListPage = initView({
  form: {
    pageHeader: 'Liquid Rental Billing',
    permissions: billingPermissions,
    breadcrumbs: [
      {
        name: 'Liquid Rental Billing',
        icon: 'currency-dollar',
        to: '/billing/liquid',
      },
    ],
    toolbar: [
      {
        type: FormItemType.button,
        label: 'Create Invoice',

      }
    ],
    items: [
      {
        type: FormItemType.tab,
        items: [
          {
            label: 'Unbilled Rentals',
        /*     mountOnEnter: false, */
            badgeCounter: (state) => {
              return state.liquidrentalbill?.data?.length;
            },
            items: [
              {
                items: [
                  {
                    type: FormItemType.customComponent,
                    component: LiquidRentalsListView,
                    name: 'unbilledList'
                  }
                ]
              }
            ]
          },
          {
            label: 'Invoices',
    /*         mountOnEnter: false, */
            badgeCounter: (state) => {
              let count = state.liquidRB?.data?.filter(x => [0, 9].includes(x.status) && !x.jdebypassed).length;
              if(count == 100) count = `${count}+`;
              return count;
            },
            items: [
              {
                items: [
                  {
                    type: FormItemType.customComponent,
                    component: BillingLiquidRentalListView,
                    name: 'liquidRentalBillingList'
                  }
                ]
              }
            ]
          },
          {
            label: 'MTD Rentals',
            mountOnEnter: true,
     /*        badgeCounter: (state) => {
              return state.liquidrentalmtd?.data?.length;
            }, */
            items: [
              {
                items: [
                  {
                    type: FormItemType.customComponent,
                    component: LiquidRentalsListViewMTD,
                    name: 'mtdList'
                  }
                ]
              }
            ]
          },
        ]
      }
    ]
  } as FormView, dataSource: liquidrentalordersDS
});
